import type { Compass as CompassType, Point } from '../types';

export const createCompass = (position: Point): CompassType => {
  return {
    type: 'compass',
    position,
    rotation: 0, // Default to pointing north
    size: 40, // Default size
  };
};

/**
 * Check if a point is on the compass rotation control
 */
export const isPointOnCompassRotationControl = (
  point: Point,
  compass: CompassType,
  threshold: number = 20
): boolean => {
  const controlX = compass.position.x + compass.size * 1.3;
  const controlY = compass.position.y;
  const dist = Math.hypot(point.x - controlX, point.y - controlY);
  // Use larger hit area to match the bigger visual handle (0.35 size)
  const handleRadius = compass.size * 0.35;
  return dist <= Math.max(handleRadius, threshold);
};

/**
 * Check if a point is inside the compass for selection
 */
export const isPointInsideCompass = (point: Point, compass: CompassType): boolean => {
  const dist = Math.hypot(point.x - compass.position.x, point.y - compass.position.y);
  return dist <= compass.size;
};
